(function () {
  const MODAL_ID = 'paOkendoModal';
  const FRAME_ID = 'paOkendoModalFrame';

  function els() {
    return {
      modal: document.getElementById(MODAL_ID),
      frame: document.getElementById(FRAME_ID),
    };
  }

  let loadCount = 0;
  let openedAt = 0;

  function closeModal() {
    const { modal, frame } = els();
    if (!modal || !frame) return;

    modal.hidden = true;
    frame.src = 'about:blank';
    document.documentElement.classList.remove('pa-okendo-modal-open');

    loadCount = 0;
    openedAt = 0;
  }

  function openModal(url) {
    const { modal, frame } = els();
    if (!modal || !frame) return;

    loadCount = 0;
    openedAt = Date.now();

    modal.hidden = false;
    document.documentElement.classList.add('pa-okendo-modal-open');

    // IMPORTANT: use addEventListener so we don't clobber other handlers
    const onLoad = () => {
      loadCount += 1;

      // Try same-origin URL checks (usually blocked, but safe to attempt)
      try {
        const href = frame.contentWindow.location.href || '';
        if (/submitted|thank|success|verify/i.test(href)) {
          closeModal();
          return;
        }
        if (href.includes('pureamor.com')) {
          closeModal();
          return;
        }
      } catch (err) {
        // Cross-origin: expected
      }

      // Cross-origin fallback heuristic:
      // Close on the 2nd meaningful page load (submission success page),
      // but only after a short delay so we don't close on quick internal reloads.
      if (loadCount >= 2 && Date.now() - openedAt > 2500) {
        closeModal();
      }
    };

    // Remove previous listener if any, then add a fresh one
    frame._paOnLoad && frame.removeEventListener('load', frame._paOnLoad);
    frame._paOnLoad = onLoad;
    frame.addEventListener('load', onLoad);

    frame.src = url;
  }

  // Intercept Okendo Write Review link (capture phase beats target=_blank)
  document.addEventListener(
    'click',
    function (e) {
      const link = e.target.closest(
        '.oke-w-reviews-writeReview a.oke-w-writeReview[href*="okendo.reviews"]'
      );
      if (!link) return;

      e.preventDefault();
      openModal(link.href);
    },
    true
  );

  // Close via X/backdrop
  document.addEventListener('click', (e) => {
    const { modal } = els();
    if (!modal || modal.hidden) return;
    if (e.target.closest('[data-pa-okendo-close]')) closeModal();
  });

  // ESC to close
  window.addEventListener('keydown', (e) => {
    const { modal } = els();
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') closeModal();
  });

  //if Okendo ever sends messages in the future, support it
  window.addEventListener('message', (event) => {
    const origin = event.origin || '';
    if (!origin.includes('okendo')) return;

    const data = event.data;
    const text = typeof data === 'string' ? data : JSON.stringify(data || {});
    if (/submitted|success|verify/i.test(text.toLowerCase())) closeModal();
  });


   // expose for use in other pages (account modal, etc.)
  //window.paOpenOkendoModal = openModal;

  // expose for debugging
  window.paCloseOkendoModal = closeModal;
})();
